import * as style from '../../utils/general_style.js';
import RequiredSpan from '../form/RequiredSpan';

function CustomInput({ label, type, name, required, onChange, onBlur, validationState, keyword, options, form, devidedInputs, list=false, size}) {
    let element;
    const divStyle = (list) ? {width: '98%'} : {flex: '1 1 48%', maxWidth: (size === 'full') ? '100%' : '48%'};

    switch(type) {
        case "select": {
            element = 
            <>
                <label htmlFor={ name } style={{marginBottom: style.SPACE.small}}>{ label }<RequiredSpan required={ required }/></label>
                <select name={ name } id={ name } style={style.INPUT} defaultValue={sessionStorage.getItem(`${keyword}_${name}`.toString()) || ''} required onChange={ onChange }>
                    {options.filter(option => option.forms.includes(form)).map(({ value, label }, index) => (
                        <option value={value} key={index} disabled={(value==='') ? true : false}>{label}</option>
                    ))}
                </select>
            </>
            break;
        }
        case "devided": {
            element =
            <>
                <div style={style.ROW_SPACE_BETWEEN}>
                    {devidedInputs.map(( devidedInput, index) => (
                        <div style={{...style.COLUMN_START, width: '100%', maxWidth: devidedInput.size }} key={index}>
                            <label htmlFor={ devidedInput.name } style={{marginBottom: style.SPACE.small}}>{ devidedInput.label }<RequiredSpan required={ devidedInput.required }/></label>
                            <input type={ devidedInput.type } name={ devidedInput.name } id={ devidedInput.name } style={style.INPUT} required={ devidedInput.required } onChange={ onChange } defaultValue={sessionStorage.getItem(`${keyword}_${devidedInput.name}`.toString())} onBlur={ onBlur } />
                        </div>
                    ))}
                </div>
            </>
            break;
        }
        default: {
            element =
            <>
                <label htmlFor={ name } style={{marginBottom: style.SPACE.small}}>{ label }<RequiredSpan required={ required }/></label>
                <input type={ type } name={ name } id={ name } style={style.INPUT} required={ required } onChange={ onChange } defaultValue={sessionStorage.getItem(`${keyword}_${name}`.toString())} onBlur={ onBlur } />
            </>
            break;
        }
    }
    
    return (
        <div style={{...style.COLUMN_START, ...divStyle, margin: `${style.SPACE.small} 0px`}}>
            { element }
            <span style={{opacity: validationState, color: 'red', fontSize: '12px'}}>L'information indiquée ne semble pas être conforme</span>
        </div>
	);
};

export default CustomInput;